import React, { useState } from 'react';
import Hero from '../components/Hero';
import AnimatedPage from '../components/AnimatedPage';
import Countdown from '../components/Countdown';
import '../styles/App.css'; 

const Home = () => {
  return (
    <div>
      <AnimatedPage>
        <Hero />
      </AnimatedPage>
    </div>
  );
};

export default Home;
